import React, { useRef } from "react";

type CardData = {
  id: number;
  name: string;
  Responsibility: string;
  imageUrl: string;
  avatarUrl: string;
};

const Members = ({ cards }: { cards: CardData[] }) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: "left" | "right") => {
    if (scrollRef.current) {
      const scrollAmount = direction === "left" ? -300 : 300;
      scrollRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }
  };

  return (
    <div>
      <div className="my-10" />
      <h3 className="mb-6 text-2xl font-extrabold text-accentAlt/85">Members</h3>

      <div className="relative">
        {/* Left Arrow */}
        <button
          onClick={() => scroll("left")}
          className="absolute left-0 top-1/2 transform -translate-y-1/2 z-10 bg-white shadow rounded-full w-10 h-10 flex items-center justify-center"
          aria-label="Scroll members list to the left"
          title="Scroll left"
        >
          <svg
            width="12"
            height="24"
            viewBox="0 0 18 32"
            fill="none"
            aria-hidden="true"
          >
            <path fillRule="evenodd" clipRule="evenodd" d="M16.1198 0C16.8392 0.000205755 17.4877 0.433626 17.763 1.09829C18.0383 1.7629 17.8861 2.52802 17.3775 3.03667L4.40333 16.0109L17.3775 28.9851C18.0517 29.6832 18.0613 30.7927 17.3751 31.4789C16.6889 32.1652 15.5793 32.1748 14.8813 31.5006L0.649366 17.2687C-0.0451493 16.574 -0.0451493 15.4479 0.649366 14.7532L14.8813 0.521216C15.2149 0.187576 15.6673 1.52671e-07 16.1391 0Z" fill="#B6B9BB" />
          </svg>
        </button>

        {/* Scroll Container */}
        <div
          ref={scrollRef}
          className="flex gap-4 overflow-x-auto scrollbar-hide scroll-smooth"
          role="region"
          aria-label="Team members list"
        >
          {cards.map((item) => (
            <div
              key={item.id}
              className="min-w-[300px] bg-background rounded-lg shadow relative flex-shrink-0"
            >
              {/* Background & Avatar */}
              <div className="relative w-full h-[180px]">
                <img
                  src={item.imageUrl}
                  alt={`${item.name}'s background image`}
                  className="w-full h-full object-cover rounded-t-lg opacity-85"
                />
                <div className="absolute -bottom-10 left-1/2 transform -translate-x-1/2">
                  <img
                    src={item.avatarUrl}
                    alt={`${item.name}'s profile picture`}
                    className="w-20 h-20 rounded-full border-4 bg-white border-background shadow-lg object-cover"
                  />
                </div>
              </div>

              {/* Content */}
              <div className="pt-14 pb-6 px-4 text-center">
                <h4 className="font-semibold text-lg text-primary">{item.name}</h4>
                <p className="text-sm text-primary/85">{item.Responsibility}</p>
                {/*<button
                  className="mt-4 border border-primary text-primary bg-transparent text-sm px-6 py-2 rounded-full hover:bg-primary hover:text-white transition"
                  aria-label={`Learn more about ${item.name}`}
                >
                  More
                </button>*/}
              </div>
            </div>
          ))}
        </div>

        {/* Right Arrow */}
        <button
          onClick={() => scroll("right")}
          className="absolute right-0 top-1/2 transform -translate-y-1/2 z-10 bg-white shadow rounded-full w-10 h-10 flex items-center justify-center"
          aria-label="Scroll members list to the right"
          title="Scroll right"
        >
          <svg
            width="12"
            height="24"
            viewBox="0 0 18 32"
            fill="none"
            aria-hidden="true"
          >
            <path fillRule="evenodd" clipRule="evenodd" d="M1.88023 32C1.16081 31.9998 0.512299 31.5664 0.237011 30.9017C-0.0382774 30.2371 0.113851 29.472 0.622479 28.9633L13.5967 15.9891L0.622479 3.01488C-0.0517093 2.31684 -0.0420675 1.20727 0.64415 0.521055C1.33037 -0.165162 2.43994 -0.174804 3.13797 0.499384L17.3699 14.7313C18.0644 15.426 18.0644 16.5521 17.3699 17.2468L3.13797 31.4788C2.80443 31.8124 2.35201 31.9999 1.88023 32Z" fill="#B6B9BB" />\
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Members;